import { rand } from 'helpers/sharedHelpers';

/** ***  DEMO FLAG, if TRUE, we're in demo mode! Don't commit to web main branch,
 * we don't want the auto-build to deploy as a demo. Only set when building
 * for Steam.  *** */
const demoSetFromEnv =
  typeof __DEMO_MODE__ !== 'undefined' ? __DEMO_MODE__ : false;
export const DEMO_MODE = demoSetFromEnv || false;
const sharedLevelSetFromEnv =
  typeof __SHARED_LEVEL_MODE__ !== 'undefined' ? __SHARED_LEVEL_MODE__ : false;
export const SHARED_LEVEL_MODE = sharedLevelSetFromEnv || false;
const desktopSetFromEnv =
  typeof __DESKTOP_MODE__ !== 'undefined' ? __DESKTOP_MODE__ : null;
const runtimeProcess =
  typeof window !== 'undefined' && window.process
    ? window.process
    : typeof process !== 'undefined'
    ? process
    : null;
export const DESKTOP_MODE =
  desktopSetFromEnv !== null
    ? desktopSetFromEnv
    : !!(
        runtimeProcess &&
        runtimeProcess.versions &&
        runtimeProcess.versions.nw
      );

/** *** VERSION NUMBER - UPDATING WILL WIPE PLAYER DATA *****/
export const VERSION = '0.5.3';

//first level for the story mode
export const STARTING_INDEX = '16';

export const cursorCSS = {
  1: "url('assets/images/ui/cursor.png'), pointer",
  2: "url('assets/images/ui/cursor2x.png'), pointer",
  3: "url('assets/images/ui/cursor3x.png'), pointer"
};
export const cursorHandCSS = "url('assets/images/ui/handCursor.png'), pointer";

export const SIDEBAR_WIDTH = 348;
export const TIMELINE_BAR_HEIGHT = 100;
export const DEFAULT_LEVEL_MUSIC = 'music_battle';
export const LEVEL_MUSIC_OPTIONS = [
  { value: 'music_battle', label: 'Patzerton Battle' },
  { value: 'music_town', label: 'Patzerton' },
  { value: 'music_forest', label: 'Fickle Woods' },
  { value: 'music_forest_town', label: 'Forest Camp' },
  { value: 'music_forest_battle', label: 'Forest Battle' },
  { value: 'music_forest_boss', label: 'Forest Boss' },
  { value: 'music_gmas_basement', label: "Gma's Basement" },
  { value: 'music_queens_fire', label: "Queen's Fire" },
  { value: 'music_lofi_theme', label: 'Lofi Theme' },
  { value: 'music_night', label: 'Night' },
  {
    value: 'music_forest_town_destroyed',
    label: 'Forest Camp Destroyed'
  }
];

export const OBJECT_CATEGORY = {
  WALL: 'wall',
  DOOR: 'door',
  MISC: 'misc'
};

export const COLORS = {
  LIGHT_YELLOW: '#f5f2d0',
  BROWN: '#785116',
  BLACK: '#14191c',
  GOLD: '#bf7810',
  LIGHT_GOLD: '#f99c10',
  LIGHT_BLUE: '#5b87a1',
  LIGHT_MID_BLUE: '#5d87a0',
  DARK_BLUE: '#1f272c',

  PIECE_MID_BLUE: '#1279ae',

  PIECE_MID_RED: '#b62738',
  GOLD_BUTTON_HOVER: '#e5dbb3',
  DARK_GREY: '#242424',
  LIGHT_GREY_TEXT: '#999999',
  BLUE_GREY_TEXT: '#6B818C'
};

export const COLORS_RGB = {
  BLACK: { R: 20, G: 25, B: 28 }
};

export const BIOMES = {
  forest_town: {
    areaRectangles: [{ x: 125, y: 49, w: 23, h: 10 }],
    name: 'Forest Camp',
    title_indicator_sprite: 'forest',
    musicTrack: 'music_forest_town',
    ambienceTrack: 'ambience_forest',
    battleMusic: 'music_forest_battle'
  },
  mountains: {
    areaRectangles: [{ x: 88, y: 0, w: 62, h: 15 }],
    name: 'Mountains',
    title_indicator_sprite: 'mountains',
    musicTrack: 'music_town',
    ambienceTrack: 'ambience_town_birds',
    battleMusic: 'music_battle'
  },
  forest: {
    areaRectangles: [
      { x: 66, y: 0, w: 83, h: 46 },
      { x: 87, y: 47, w: 63, h: 22 }
    ],
    name: 'Fickle Woods',
    title_indicator_sprite: 'forest',
    musicTrack: 'music_forest',
    ambienceTrack: 'ambience_forest',
    battleMusic: 'music_forest_battle'
  },
  patzerton: {
    areaRectangles: [{ x: 45, y: 52, w: 38, h: 57 }],
    name: 'Patzerton',
    title_indicator_sprite: 'overworld',
    musicTrack: 'music_battle',
    ambienceTrack: 'ambience_town_bells',
    battleMusic: 'music_battle'
  },
  // default covers whole map, catches anything not caught in other biomes
  default: {
    areaRectangles: [{ x: 0, y: 0, w: 150, h: 150 }],
    name: 'Chesslike World Name',
    title_indicator_sprite: 'overworld',
    musicTrack: 'music_town',
    ambienceTrack: 'ambience_town_birds',
    battleMusic: 'music_battle'
  }
};

export const WEAPON_RANKS = {
  sword: 1,
  scepter: 2,
  axe: 3,
  crown: 4
};

export const PIECE_TYPES = [
  'Pawn',
  'Knight',
  'Bishop',
  'Rook',
  'Queen',
  'King',
  'Beast'
];

export const COLORLESS_TYPES = ['Pawn', 'Pawn'];

export const PIECE_SHORTS = ['P', 'H', 'B', 'R', 'Q', 'K'];

export const TARGET_TILE = 620;
export const PIECE_SHADOW = 619;
export const LOGIC_DOOR = 618;
export const WALKABLE = 617;
export const UNWALKABLE = 616;
export const SHADOW = 378;
export const DOORS = [
  27,
  28,
  31,
  32,
  34,
  63,
  64,
  99,
  100,
  103,
  139,
  141,
  154,
  171,
  172,
  175,
  207,
  211,
  212,
  387, //WORLD_DOOR
  618 // LOGIC_DOOR
  // 445 //LOCKED_DOOR
];
export const BIG_DOORS = [
  31,
  32,
  88,
  103,
  108,
  139,
  142,
  175,
  176,
  211,
  212,
  387,
  663,
  707,
  825
];

export const SMALL_PIECES = [235, 271, 277, 283, 307, 313, 319];
export const COLORLESS_PIECES = [235, 236];
export const BLUE_PIECES = [271, 272, 273, 274, 275, 276, 283, 239, 240];

export const CHARACTERS = {
  fayette: 283,
  gma: 235,
  sam: 236,
  raide: 237,
  angryQueen: 238,
  uncle: 239,
  forestElder: 240,
  patzertonKing: 241
};

// also hardcoded in movementeHelpers.getPieceMoveSet
export const isQueenPiece = pieceIndex => QUEEN_PIECES.includes(pieceIndex);
// all queen pieces, including the unique characters
export const QUEEN_PIECES = [311, 317, 275, 281, CHARACTERS.angryQueen];

export const RED_PIECES = [
  307,
  308,
  309,
  310,
  311,
  312,
  319,
  320,
  321,
  322,
  323,
  324,
  237,
  CHARACTERS.angryQueen,
  CHARACTERS.patzertonKing
];

export const RED_PIECE_RANK_INDEXES = [
  0,
  1,
  2,
  3,
  4,
  5,
  0,
  1,
  2,
  3,
  4,
  5,
  1,
  4,
  5
];

// - 0 unit origin
// - 1 move-only
// - 2 attack only
// - 3 move or attack
// - a recurse up/left
// - b recurse up
// - c recurse up/right
// - d recurse left
// - e recurse right
// - f recurse down/left
// - g recurse down
// - h recurse down/right

export const PATTERN_UNIT_ORIGIN = 0;
export const PATTERN_MOVE = 1;
export const PATTERN_ATTACK = 2;
export const PATTERN_MOVE_ATTACK = 3;

export const moveSpriteGrid = {
  '-1': 11,
  0: 12,
  1: 5,
  2: 4,
  3: 10,
  a: 3,
  b: 6,
  c: 0,
  d: 9,
  e: 7,
  f: 2,
  g: 8,
  h: 1
};

export const pieceMovesets = {
  Pawn: [
    [-1, -1, -1, -1, -1],
    [-1, 2, 1, 2, -1],
    [-1, 1, 0, 1, -1],
    [-1, 2, 1, 2, -1],
    [-1, -1, -1, -1, -1]
  ],
  Knight: [
    [-1, 3, -1, 3, -1],
    [3, -1, -1, -1, 3],
    [-1, -1, 0, -1, -1],
    [3, -1, -1, -1, 3],
    [-1, 3, -1, 3, -1]
  ],
  Bishop: [
    ['a', -1, -1, -1, 'c'],
    [-1, 3, -1, 3, -1],
    [-1, -1, 0, -1, -1],
    [-1, 3, -1, 3, -1],
    ['f', -1, -1, -1, 'h']
  ],
  Rook: [
    [-1, -1, 'b', -1, -1],
    [-1, -1, 3, -1, -1],
    ['d', 3, 0, 3, 'e'],
    [-1, -1, 3, -1, -1],
    [-1, -1, 'g', -1, -1]
  ],
  Queen: [
    ['a', -1, 'b', -1, 'c'],
    [-1, 3, 3, 3, -1],
    ['d', 3, 0, 3, 'e'],
    [-1, 3, 3, 3, -1],
    ['f', -1, 'g', -1, 'h']
  ],
  King: [
    [-1, -1, -1, -1, -1],
    [-1, 3, 3, 3, -1],
    [-1, 3, 0, 3, -1],
    [-1, 3, 3, 3, -1],
    [-1, -1, -1, -1, -1]
  ],
  Beast: [
    [3, 3, 3, 3, 3],
    [3, -1, -1, -1, 3],
    [3, -1, 0, -1, 3],
    [3, -1, -1, -1, 3],
    [3, 3, 3, 3, 3]
  ]
};

export const FAYETTE_MOVEMENT_PROPERTIES = {
  tweenDelay: 0,
  moveAgainDelay: 50,
  moveDuration: 470, // generic piece default is 300
  movementAnimationFramerate: 11
};

export const pieceScores = [2, 4, 5, 7, 10, 3];
export const colorlessPieceScores = [2, 2];

export const ZOOM_LEVELS = [0.5, 1, 2, 3, 4, 5, 6];

export const WORLD_DOOR = 387;
export const KEY = 444;
export const LOCKED_DOOR = 560; // old index for single-tile-tall: 445;
export const SWORD = 428;
export const AMULET = 576;
export const QUEENSFIRE = 594;
export const CRYSTAL = 612;
export const FOREST_BOW = 630;
export const AXE = 446;
export const SCEPTER = 464;
export const WARP = 442;
export const MAP = 443;
export const GOLD_TILES = [459, 460, 461, 462];
export const TORCH = 338;
export const SWITCH_OPEN_TOP = 709;
export const SWITCH_OPEN_BOTTOM = 727;
export const SWITCH_CLOSED_TOP = 708;
export const SWITCH_CLOSED_BOTTOM = 726;
export const GATE_HORIZONTAL_TOP = 337;
export const GATE_HORIZONTAL_BOTTOM = 355;
export const GATE_VERTICAL_TOP = 546;
export const GATE_VERTICAL_BOTTOM = 564;
export const GATE_VERTICAL_MIDDLE = 733;
export const GATE_CORNER_TOP_LEFT_BOTTOM = 768;
export const GATE_CORNER_TOP_RIGHT_BOTTOM = 769;
export const GATE_CORNER_BOTTOM_LEFT_BOTTOM = 804;
export const GATE_CORNER_BOTTOM_RIGHT_BOTTOM = 805;
export const TELEPORT_DARK = 670;
export const TELEPORT_LIGHT = 671;
export const ITEMS = [
  FOREST_BOW,
  QUEENSFIRE,
  CRYSTAL,
  SWORD,
  AMULET,
  SCEPTER,
  AXE,
  WARP,
  KEY,
  LOCKED_DOOR,
  MAP,
  ...GOLD_TILES
];
export const NON_EQUIPPABLE_ITEMS = [
  WARP,
  KEY,
  LOCKED_DOOR,
  MAP,
  ...GOLD_TILES
];
export const SINGLE_TILE_ITEMS = [
  FOREST_BOW,
  QUEENSFIRE,
  CRYSTAL,
  SCEPTER,
  AXE,
  WARP,
  KEY,
  MAP,
  LOGIC_DOOR,
  UNWALKABLE,
  WALKABLE,
  ...GOLD_TILES
];

export const HIGHLIGHT_MOVE = 613;
export const HIGHLIGHT_MOVEKILL = 614;
export const HIGHLIGHT_KILL = 615;
export const ENEMY_MOVEKILL = 623;
export const ENEMY_MOVE = 622;
export const ENEMY_KILL = 621;
export const HIGHLIGHT_NPC = 607;
export const HIGHLIGHT_NPC_HOVER = 589;
export const HIGHLIGHT_SELECTED = 624;
export const HIGHLIGHT_SELECTABLE = 625;
export const HIGHLIGHT_STAIRS_DOWN = 595;
export const HIGHLIGHT_STAIRS_UP = 596;
export const HIGHLIGHT_STAIRS_DOWN_HOVER = 577;
export const HIGHLIGHT_STAIRS_UP_HOVER = 578;
export const HIGHLIGHT_DOOR = 598;
export const HIGHLIGHT_DOOR_HOVER = 580;

export const NEW_BLANK_MAP = {
  name: '',
  preScene: () => {},
  beforeMove: () => {},
  afterMove: () => {},
  afterScene: () => {},
  equippedItems: [],
  npcs: [],
  lvlData: {
    ground: [
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1]
    ],
    belowPlayer: [
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1]
    ],
    decor: [
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1]
    ],
    abovePlayer: [
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1],
      [-1, -1, -1, -1, -1]
    ],
    logic: [
      [616, 616, 616, 616, 616],
      [616, 616, 616, 616, 616],
      [616, 616, 616, 616, 616],
      [616, 616, 616, 616, 616],
      [616, 616, 616, 616, 616]
    ]
  }
};

export function randomName() {
  return RANDOM_NAMES[rand(0, RANDOM_NAMES.length - 1)];
}

export const RANDOM_NAMES = [
  'Adam',
  'Brandon',
  'Lafayette',
  'Vildan',
  'Michael',
  'Alexandre',
  'Adelie',
  'Margot',
  'Riker',
  'Uri',
  'Erin',
  'Laura',
  'Hugo',
  'Mia',
  'Agathe',
  'Eva',
  'Gabriel',
  'Ben',
  'Charles',
  'Beth',
  'Harmon'
];

export const staffUsers = ['amoore', 'loxmyth', 'Zewa', 'tester9', 'Tester9'];

/**
 * Custom DOM events fired in Puppeteer playtesting mode at specific timings
 * to automate the playthrough session
 */
export const CUSTOM_DOM_EVENTS = {
  GameReady: 'game-ready',
  MenuReady: 'menu-ready',
  CommandDispatch: 'command-dispatch'
};
